<script>
  import { goto } from '@sapper/app';

  import { productDataStore } from '../../stores/ProductData.js';
  import { isMobile, designTabActive, editingElement } from '../../stores/Designer.js';

  export let icons;
  export let currentStep;
  export let designSteps;

  async function changeStep(direction) {
    $editingElement = null;
    let url;
    let nextIndex;
    let slug;
    if ($productDataStore.top) {
      slug = $productDataStore.top.slug;
    } else {
      slug = $productDataStore[$productDataStore.showing].slug;
    }
    if (direction === 'prev') {
      nextIndex = currentStep.stepNumber - 2;
    } else {
      nextIndex = currentStep.stepNumber;
    }
    if (nextIndex >= 0 && nextIndex <= designSteps.length - 1) {
      let nextStep = designSteps[nextIndex];
      url = '/design/' + slug + '/' + nextStep.segment;
      await goto(url, { noscroll: true });
      currentStep = designSteps[nextIndex];
    } else {
      return;
    }
  }
</script>

<div
  class="step-nav"
  class:step-nav-mobile={$isMobile}
  class:panel-active={$designTabActive && currentStep.stepNumber !== 5 && currentStep.stepNumber !== 6}
>
  <span class="arrow" class:disabled={currentStep.stepNumber === 1} on:click={() => changeStep('prev')}>
    {@html icons.arrowLeft}
  </span>

  <div class="step">
    STEP {currentStep.stepNumber} :
    <span class="orange"><h1>{currentStep.label}</h1></span>
  </div>
  <span
    class="arrow"
    class:disabled={currentStep.stepNumber === designSteps.length}
    on:click={() => changeStep('next')}
  >
    {@html icons.arrowRight}
  </span>
</div>

<style>
  .arrow {
    width: 4rem;
    height: 4rem;
    border-radius: 0.5rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: white;
    background-color: #fe5900;
    box-shadow: 1px 1px 0.5rem rgba(0, 0, 0, 0.15);
    cursor: pointer;
  }

  .arrow.disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }

  .step-nav {
    display: block;
    position: sticky;
    top: 0;
    z-index: 20;
    padding-left: 1rem;
    padding-right: 1rem;
    height: 50px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  }

  .step-nav.step-nav-mobile {
    position: fixed;
    top: auto;
    bottom: 0;
    width: 100%;
    height: 50px;
    overflow: hidden;
    border-top: 1px solid rgba(0, 0, 0, 0.15);
    z-index: 100;
  }

  .step-nav.step-nav-mobile.panel-active {
    display: none;
  }

  .step {
    display: flex;
  }

  .orange {
    color: #fe5900;
    font-weight: 600;
  }

  h1 {
    font-size: 1.6rem;
    margin-left: 1rem;
  }
</style>
